import { usePolicyEvaluate } from 'components/policy-loader/policy-loader';

export const useCanEditOrganization = () => {
  return usePolicyEvaluate('editOrganization', 'organization');
};
